module.exports = __webpack_public_path__ + "static/imagine-yourself-0a4b761c9a43fe1d9544dfb7d86c1906.jpg";